import 'twin.macro';
import React from 'react';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function SmallNumber(props: Props) {
  return (
    <div
      tw="ml-1.5 rounded py-0.5 px-1.5 bg-neutral-quiet text-xs font-semibold text-neutral-moderate tabular-nums"
      className={clsx(props.className)}
    >
      {props.children}
    </div>
  );
}
